import { PlusCircleIcon } from '@heroicons/react/24/outline';
import { default as Modal } from 'antd/es/modal';
import { useState } from 'react';

import { ACCOUNTS_FUNDING_MODAL_ACCOUNT_SELECTOR_TEST_ID } from '@organisms/Sidebar/constants';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { SelectVirtualAccount } from '@molecules/SelectVirtualAccount';

interface FundingDetailsComponentProps {
  virtualAccountNumber: string;
}

type Props = {
  open: boolean;
  FundingDetailsComponent: ({
    virtualAccountNumber
  }: FundingDetailsComponentProps) => JSX.Element;
  onClose: (value: boolean) => void;
};

export const FundingInformationDialog = ({
  open,
  onClose,
  FundingDetailsComponent
}: Props) => {
  const [virtualAccountNumber, setVirtualAccountNumber] = useState<string>();

  const onDialogClose = (value: boolean) => {
    onClose(value);

    // Reset selected account everytime the dialog gets closed.
    setVirtualAccountNumber(undefined);
  };

  return (
    <Modal
      open={open}
      onCancel={() => onDialogClose(false)}
      destroyOnHidden
      centered
      styles={{
        content: {
          width: 436
        }
      }}
      className="ant-modal-no-padding"
      title={
        <div className="flex h-12 items-center gap-2 pl-6">
          <PlusCircleIcon className="size-7 shrink-0" />
          <div className="grow text-lg font-medium">
            <span>Account funding</span>
          </div>
        </div>
      }
      footer={null}
    >
      <div className="overflow-visible p-6">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col">
            <div className="mb-3 text-xs font-semibold text-content-secondary">
              Account
            </div>
            <SelectVirtualAccount
              currentAccountNumber={virtualAccountNumber}
              onChangeCallback={setVirtualAccountNumber}
              allowAll={false}
              filterTerminatedAccounts={true}
              filterSuspendedAccounts={true}
              className="w-[389px]"
              e2eId={ACCOUNTS_FUNDING_MODAL_ACCOUNT_SELECTOR_TEST_ID}
            />
          </div>
          {virtualAccountNumber ? (
            <FundingDetailsComponent
              virtualAccountNumber={virtualAccountNumber}
            />
          ) : (
            <div className="rounded-2xl bg-surface-neutral p-3 text-sm">
              Select account to see the funding instructions.
            </div>
          )}

          <PrimaryButton
            className="w-full"
            onClick={() => {
              onDialogClose(false);
            }}
          >
            Done, close window
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};
